import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { PreviewSection } from '../SendCampaign/StyledComponents';
import PhoneMockup from './PhoneMockup';

const MessagePreview = ({
  channel,
  message,
  pushTitle,
  showTitle = true,
  compact = false,
  attachments = [],
}) => {
  const theme = useContext(ThemeContext);

  return (
    <PreviewSection
      compact={compact}
      title={
        showTitle ? (
          <>
            <svg
              width="16"
              height="16"
              fill={theme?.colors?.primary || '#FA4616'}
              viewBox="0 0 16 16"
              style={{ marginRight: '8px' }}
            >
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
            </svg>
            Live Preview
          </>
        ) : undefined
      }
    >
      <PhoneMockup
        channel={channel}
        message={message}
        pushTitle={pushTitle}
        attachments={attachments}
        theme={theme}
      />
    </PreviewSection>
  );
};

MessagePreview.propTypes = {
  channel: PropTypes.oneOf(['SMS', 'Push']).isRequired,
  message: PropTypes.string.isRequired,
  pushTitle: PropTypes.string,
  showTitle: PropTypes.bool,
  compact: PropTypes.bool,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      sizeFormatted: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
};

MessagePreview.defaultProps = {
  showTitle: true,
  compact: false,
};

export default MessagePreview;
